const isLocalhost = window.location.hostname === "localhost";

// TODO: this will have to be reworked when deploying for multiple clients
export const API_BASE_URL = isLocalhost
  ? "https://localhost:7127"
  : `${window.location.origin}/Apis`;
